const memberModel = require("../../model/report/member");

exports.fetchPhoneData = async (startDate, endDate, page, searchType, keyword) => {
  try {
    let salesByMemberData = await memberModel.salesByMember(startDate, endDate, page, searchType, keyword);
    const processedData = salesByMemberData.data.map(item => ({
      phone: item.Member?.phone || '-',
      address: item.Member?.address || '-',
      name: item.Member?.name || '-',
      grandTotal: item.grandTotal || '-',
      productPRUTypeName: item.productPRUType?.name || '-',
      typeOfOrder: item.typeOfOrder || '-'
    }));
    const metaData = {
      items: salesByMemberData.paginate.items || 0,
      pageCount: salesByMemberData.paginate.pageCount,
      currentPage: salesByMemberData.paginate.currentPage,
      itemCount: salesByMemberData.paginate.itemCount,
      limit: salesByMemberData.paginate.perPage
    };
    return {processedData, metaData };
  } catch (error) {
    console.error('Error fetching table data:', error);
    return null;
  }
}

exports.exportPhoneReport = async (startDate, endDate, locale, searchType, keyword) => {
  try {
    const result = await memberModel.exportPhoneReport(startDate, endDate, locale, searchType, keyword);
    return result;
  } catch (error) {
    console.error('Error exporting Option Sales by Cost Report:', error);
    return null;
  }
}
